import React from 'react';

const Banner = () => {
  return (
    <section className="heroSection">
      <div className="heroContent">
        <span className="heroChip">Portfolio-worthy React project</span>
        <h2>Responsive shopping experience with real interactivity</h2>
        <p>
          Browse products, filter by category, sort by price, explore product details,
          and manage a persistent cart with quantity controls.
        </p>
        <div className="heroStats">
          <div>
            <strong>18+</strong>
            <span>Products</span>
          </div>
          <div>
            <strong>3</strong>
            <span>Categories</span>
          </div>
          <div>
            <strong>100%</strong>
            <span>Responsive UI</span>
          </div>
        </div>
      </div>

      <div className="heroImageCard">
        <img src="/Assets/GentsBanner.gif" alt="Shopping banner" />
      </div>
    </section>
  );
};

export default Banner;
